import { jsx as _jsx } from "react/jsx-runtime";
import { Result } from "antd";
const AccessDenied = () => {
    return (_jsx(Result, { status: "403", title: "403", subTitle: "Sorry, you are not authorized to access this page.", style: { height: "calc(100vh - 64px)" } }));
};
export default AccessDenied;
